import DanhSachKeHoachThanhTra from './DanhSachKeHoachThanhTra.jsx';
import DanhSachKeHoachThanhTraDaPheDuyet from './DanhSachKeHoachThanhTraDaPheDuyet.jsx';
import ThemMoiKeHoachThanhTra from './ThemMoiKeHoachThanhTra.jsx';
import DanhSachCuocThanhTra from './DanhSachCuocThanhTra.jsx';
import DanhSachDoiTuongTrung from './DanhSachDoiTuongTrung.jsx';
import ChiTietDoiTuongTrung from './ChiTietDoiTuongTrung.jsx';
import ThemMoiCuocThanhTra from './ThemMoiCuocThanhTra.jsx';
import ChiTietCuocThanhTra from './ChiTietCuocThanhTra.jsx';
import ChinhSuaCuocThanhTra from './ChinhSuaCuocThanhTra.jsx';

export {
  DanhSachKeHoachThanhTra,
  DanhSachKeHoachThanhTraDaPheDuyet,
  ThemMoiKeHoachThanhTra,
  DanhSachCuocThanhTra,
  DanhSachDoiTuongTrung,
  ChiTietDoiTuongTrung,
  ThemMoiCuocThanhTra,
  ChiTietCuocThanhTra,
  ChinhSuaCuocThanhTra,
}


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/index.js